const initialState = {
  scanning: false,
  productScanned: null,
  lotsScanned: [],
  frontCamera: true,
};

function scannerReducer(state = initialState, action = '') {
  switch (action.type) {
    case 'scanner/start':
      return {
        ...state,
        scanning: true,
        productScanned: null,
      };
    case 'scanner/stop':
      return {
        ...state,
        scanning: false,
      };
    case 'scanner/productDetected':
      return {
        ...state,
        productScanned: action.payload,
        scanning: false,
      };
    case 'scanner/lotsDetected':
      return {
        ...state,
        lotsScanned: action.payload,
        scanning: false,
      };
    case 'scanner/switchCamera':
      return {
        ...state,
        frontCamera: !state.frontCamera,
      };
    default:
      return state;
  }
}

export default scannerReducer;
